export default [
  //主页
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '主页',
      keepAlive: false
    },
    component: () => import('../views/Home.vue')
  },
  // 计算
  {
    path: '/count',
    name: 'Count',
    meta: {
      title: '计算',
      keepAlive: true,
      isBack: false
    },
    component: () => import('../views/Count.vue')
  },
  // 两联供选型
  {
    path: '/HeatingCooling',
    name: 'HeatingCooling',
    meta: {
      title: '两联供选型',
      keepAlive: true,
      isBack: false
    },
    component: () => import('../views/HeatingCooling.vue')
  },
  // 热水选型
  {
    path: '/HotWater',
    name: 'HotWater',
    meta: {
      title: '热水选型',
      keepAlive: true,
      isBack: false
    },
    component: () => import('../views/HotWater.vue')
  },
  // 商用冷暖选型
  {
    path: '/Heating',
    name: 'Heating',
    meta: {
      title: '商用冷暖选型',
      keepAlive: true,
      isBack: false
    },
    component: () => import('../views/Heating.vue')
  },
  // 结果
  {
    path: '/result',
    name: 'Result',
    meta: {
      title: '计算结果',
      keepAlive: false
    },
    component: () => import('../views/Result.vue')
  },
  // 404
  {
    path: '/404',
    name: '404',
    meta: {
      title: '报错了',
      keepAlive: false
    },
    component: () => import('../views/404.vue')
  },
  // 数据统计表
  {
    path: '/list',
    name: 'list',
    meta: {
      title: '统计表',
      keepAlive: false
    },
    component: () => import('../views/List.vue')
  },
  // 数据统计表
  {
    path: '/Developing',
    name: 'Developing',
    meta: {
      title: '功能开发中',
      keepAlive: false
    },
    component: () => import('../views/Developing.vue')
  }
]